module.exports = __webpack_public_path__ + "images/40b9512c655e2cb5df8db342b337aacf-c5.jpg";